<template>
    <div class="rounded-lg shadow bg-gray-900 bg-no-repeat flex w-full lg:w-80">
        <div class="flex border-2 border-gray-200 border-opacity-10 rounded-lg w-full p-2">
            <div class="flex ml-3">
                <img class="w-48 my-auto" :src="tokenPackage.icon" />
            </div>

            <div class="flex flex-col w-full ml-3 p-2">
                <span class="w-full flex font-bold text-white text-left">
                    <p class="text-md sm:text-lg sm:h-fit mb-0">{{ tokenPackage.play_tokens }} Stars</p>
                </span>
                
                <span class="flex pt-1 pb-3">
                    <p class="inline box-shadow-sm text-white text-md sm:text-xl my-auto">&pound;{{tokenPackage.price / 100}}</p>
                    <img class="inline w-[22px] my-auto stroke-2 ml-2" src="images/coin-and-tokens/cash.svg" />
                </span>

                <button @click="buy()"
                        class="shadow-xl font-bold rounded-md p-1 w-full bg-racing-stars-yellow text-black mb-3 hover:bg-yellow-400"
                    >
                    Purchase
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { getCurrentInstance, computed, ref,  onMounted } from 'vue'
import { CheckIcon } from '@heroicons/vue/outline'

export default {
    props: {
        modelValue: Number,
        packages: {
            type: Array,
            default: []
        },
        tokenPackage: {
            type: Object,
            default: []
        },
        user: {
            type: Object,
            default: {}
        },
    },

    components: {
        CheckIcon,
    },

    emits: ['tokenPackageSelected', 'openPurchaseMenu'],

    setup(props, { emit }) {
        const windowWidth = ref(window.innerWidth)

			const setWindowDimensions = () => {
				windowWidth.value = window.innerWidth
			}

			const isMobile = computed(() => {
				if (windowWidth.value < 1024) {
					return true
				}

				return false
			})

			onMounted(() => {
				setWindowDimensions()

				window.addEventListener('resize', setWindowDimensions)
			})

        const isFTDBonusEligible = (tokenPackage, user) => {
            return isFTDBonusPackage(tokenPackage) &&
                user.payments.length === 0;
        }
        const isFTDBonusPackage = (tokenPackage) => {
            return tokenPackage.promo === true;
        }

        const instance = getCurrentInstance()

        const isSelected = computed(() => {
            return instance.vnode.key === props.modelValue;


        })

        const selectTokenPackage = () => {
            emit('tokenPackageSelected', instance.vnode.key)
        }

        const buy = () => {
            emit('tokenPackageSelected', instance.vnode.key)
            emit('openPurchaseMenu', instance.vnode.key)
        }

        return {
            isSelected,
            selectTokenPackage,
            buy,
            isFTDBonusEligible,
            isFTDBonusPackage,
            isMobile,
        }

    }
}
</script>
